export default __webpack_public_path__ + "static/media/Punto_04_Finocchietti_SPA_Def.8730727b.aac";